const tokenKey = "authToken";

interface JwtPayload {
    id_user?: number;
    username?: string;
    role?: string;
    exp?: number;
}

const decodeJwtPayload = (token: string): JwtPayload | null => {
    try {
        const payload = token.split(".")[1];
        if (!payload) return null;
        const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
        const json = decodeURIComponent(
            atob(base64)
                .split("")
                .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
                .join("")
        );
        return JSON.parse(json);
    } catch {
        return null;
    }
};

const getToken = (): string | null => {
    return window.localStorage.getItem(tokenKey);
};

const getIdWithToken = (): number => {
    const t = window.localStorage.getItem(tokenKey);
    if (t) {
        const r = decodeJwtPayload(t.split(" ")[1]);
        if (r?.id_user) {
            return r.id_user;
        }
    }
    return -1;
};

const getUserNameWithToken = (): string => {
    const t = window.localStorage.getItem(tokenKey);
    if (t) {
        const r = decodeJwtPayload(t.split(" ")[1]);
        if (r?.username) {
            return r.username;
        }
    }
    return "";
};

const isAdminWithToken = (): boolean => {
    const t = window.localStorage.getItem(tokenKey);
    if (t) {
        const r = decodeJwtPayload(t.split(" ")[1]);
        if (r?.role) {
            return r.role.toUpperCase() === "ADMIN";
        }
    }
    return false;
};

const setToken = (token: string): void => {
    window.localStorage.setItem(tokenKey, token);
};

const clearToken = (): void => {
    window.localStorage.removeItem(tokenKey);
};

const verifyToken = (): boolean => {
    const t = window.localStorage.getItem(tokenKey);
    if (t) {
        const decodeToken = decodeJwtPayload(t.split(" ")[1]);
        if (!decodeToken) {
            return false;
        }
        if (decodeToken.exp && decodeToken.exp < Date.now() / 1000) {
            clearToken();
            return false;
        }
        return true;
    }
    return false;
};

export { getToken, getIdWithToken, getUserNameWithToken, isAdminWithToken, setToken, clearToken, verifyToken };
